import styled from 'styled-components';

export const PageWrapperStyled = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 109.6rem;

  @media (width < 1240px) {
    width: 95%;
  }

  @media (width < 1150px) {
    width: 90%;
  }
`;
